// Generated by ScalaTS 0.8.2: https://scala-ts.github.io/scala-ts/

declare var exports: any;

export const nsVacation = exports;

export const VacationInhabitant = 'Vacation';

export type Vacation = typeof VacationInhabitant;

export function isVacation(v: any): v is Vacation {
  return VacationInhabitant == v;
}

export type VacationSingleton = Vacation;
